import { render } from "./job-view.vue?vue&type=template&id=2105e1c0"
import script from "./job-view.vue?vue&type=script&lang=js"
export * from "./job-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__